<template>
	<div class="echarts">
		<div id="main" style="width: 600px;height:400px;" />
		<div id="pie" style="width: 600px;height:400px;" />
	</div>
</template>
<script>
// var echarts = require("../../node_modules/echarts/");
import { Echarts } from "../../mixins/echarts.common";
export default {
	name: "Echarts",
	data() {
		return {};
	},
	mounted() {
		this.sampleEchart();
		this.pieEchart();
	},
	methods: {
		sampleEchart() {
			var myChart = Echarts.echarts.init(document.getElementById("main"));
			// draw chart
			myChart.setOption({
				title: {
					text: "ECharts Entry example"
				},
				tooltip: {},
				legend: {
					data: ["Sales"]
				},
				xAxis: {
					data: ["shirt", "cardign", "chiffon shirt", "pants", "heels", "socks"]
				},
				yAxis: {},
				series: [
					{
						name: "Sales",
						type: "bar",
						data: [5, 20, 36, 10, 10, 20]
					}
				]
			});
		},
		pieEchart() {
			let myChart = Echarts.echarts.init(document.getElementById("pie"));
			// draw chart
			myChart.setOption({
				series: [
					{
						name: "Reference Page",
						type: "pie",
						radius: "80%",
						data: [
							{ value: 400, name: "Searching Engine" },
							{ value: 335, name: "Direct" },
							{ value: 310, name: "Email" },
							{ value: 274, name: "Alliance Advertisement" },
							{ value: 235, name: "Video Advertisement" }
						]
					}
				]
			});
		}
	}
};
</script>
